import { getOffset, IScale } from "./TimelineScale";
import * as React from 'react';
import { ICanvasInnerComponentProps } from "./TimelineBody";
import { IBaseTimelineElement } from "./TimelineSegment";
import { SegmentCoordinates, TimelineBaseSegment } from "./TimelineBaseSegment";

export interface ITimelineBaselineSegment extends IBaseTimelineElement {
    startDate?: Date;
    finishDate: Date;
    isMilestone?: boolean;
}

export const TimelineBaselineSegment = (props: ICanvasInnerComponentProps<ITimelineBaselineSegment>) => {
    const baseline = React.useMemo(() => calculateCoordinates(props.scale, props.data, props.timelineWidth), [props.scale, props.data, props.timelineWidth]);
    return <TimelineBaseSegment coordinates={baseline} data={props.data} className="baseline" />;
}

const calculateCoordinates = (scale: IScale, baseline: ITimelineBaselineSegment, timelineWidth: number): SegmentCoordinates => {
    const markerBaselineWidth = 18;
    if (baseline.isMilestone) {
        const date = getOffset(scale, baseline.finishDate, timelineWidth);
        return {
            left: date.left,
            width: markerBaselineWidth,
            isOutOfScale: date.isOutOfScale
        };
    }
    const start = getOffset(scale, baseline.startDate!, timelineWidth);
    const end = getOffset(scale, baseline.finishDate, timelineWidth);
    return {
        left: start.left,
        width: end.left - start.left,
        trimmedStart: start.isOutOfScale,
        trimmedEnd: end.isOutOfScale,
        isOutOfScale: start.isOutOfScale && end.isOutOfScale && start.left === end.left
    };
}